import gql from "graphql-tag";

export const connectOdesToBatch = gql`
  mutation ConnectOdesToBatch($batchId: ID!, $data: BatchUpdateInput!) {
    updateBatch(
      where: { id: $batchId }
      data: $data
    ) {
      id
    }
  }
`;
